import { render, staticRenderFns } from "./RandomCallCordova.vue?vue&type=template&id=02205d4b&"
import script from "./RandomCallCordova.vue?vue&type=script&lang=js&"
export * from "./RandomCallCordova.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports